import { RefObject, useEffect, useState } from 'react';

export const useScrollPosition = (ref: RefObject<HTMLDivElement | null>) => {
  const scrollReverse =
    ref.current &&
    getComputedStyle(ref.current).flexDirection === 'row-reverse';
  const initialPosition = scrollReverse ? 'end' : 'start';
  // update state to force scrollPosition to recompute when the wrapperRef change relying on normal rerendering flow
  const [, updateState] = useState<unknown>();
  const [scrollPosition, setScrollPosition] = useState<
    'start' | 'middle' | 'end' | undefined
  >(initialPosition);

  const handleScroll = () => {
    if (ref.current) {
      const { offsetWidth, scrollLeft, scrollWidth } = ref.current;

      if (scrollLeft === 0) {
        const scrollPositionValue = scrollReverse ? 'end' : 'start';
        if (scrollPosition !== scrollPositionValue) {
          setScrollPosition(scrollPositionValue);
        }
      } else if (
        /** +1 to take into account rounding differences */
        Math.round((offsetWidth || 0) + (scrollLeft || 0)) + 1 >=
        (scrollWidth || 0)
      ) {
        const scrollPositionValue = scrollReverse ? 'start' : 'end';
        if (scrollPosition !== scrollPositionValue) {
          setScrollPosition(scrollPositionValue);
        }
      } else if (scrollPosition !== 'middle') {
        setScrollPosition('middle');
      }
    }
  };

  useEffect(() => {
    const divElement = ref.current;
    divElement?.addEventListener('scroll', updateState);
    return () => divElement?.removeEventListener('scroll', updateState);
  }, [ref]);

  handleScroll();

  return { scrollPosition };
};
